<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.exportacao"
        ref="RkmDataTable"
        sort-desc
        sort-by="dataHoraExportacao"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                :disabled="item.statusId !== enums.exportacaoStatus.PROCESSADO || !!item.encaminhado"
                @click="handleEncaminhar(item)"
                authorize="update-bpa-exportacao"
                color="primary"
                small
                title="Encaminhar"
            >
                <rkm-icon icon="share" />
            </rkm-button>

            <rkm-button
                :disabled="item.statusId !== enums.exportacaoStatus.PROCESSADO"
                @click="handleDownload(item)"
                color="primary"
                small
                title="Download"
            >
                <rkm-icon icon="download" />
            </rkm-button>

            <rkm-button
                :disabled="item.statusId === enums.exportacaoStatus.AGUARDANDO_PROCESSAMENTO || item.statusId === enums.exportacaoStatus.EM_PROCESSAMENTO || !!item.encaminhado"
                @click="handleDestroy(item)"
                authorize="destroy-bpa-exportacao"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Enums.
import exportacaoStatus from '@/enums/atencao-basica/exportacaoStatus'

// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

export default {
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('bpa.exportacao')
        }
    },
    data() {
        return {
            enums: {exportacaoStatus},
            fields: [
                { filterByFormatted: true, formatter: value => this.formatDateTime(value), key: 'dataHoraExportacao', label: 'Data / Hora da exportação', name: 'dataHoraExportacao', sortable: true },
                { key: 'competenciaValor', label: 'Competência', name: 'competencia.valor', searchable: true, sortable: true },
                { key: 'unidadeCnes', label: 'CNES', name: 'cnes' },
                { key: 'financiamentoNome', label: 'Financiamentos' },
                { key: 'statusNome', label: 'Status' },
                { key: 'quantidadeConsistencia', label: 'Quantidade de consistências' },
                { key: 'quantidadeInconsistencia', label: 'Quantidade de inconsistências' },
                { class: 'col-min text-center', key: 'actions', label: 'Ações' },
            ],
        }
    },
    methods: {
        handleEncaminhar(item) {
            const request = { encaminhado: true }

            this.repositories.exportacao.update(item.id, this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.$refs.RkmDataTable.refresh()
                    this.showSaveNotification()
                })
                .catch(this.handleError)
        },
        handleDownload(item) {
            this.repositories.exportacao.download(item.id)
                .then(response => {
                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data])
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = file
                    link.click()
                })
                .catch(this.handleError)
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.exportacao.destroy(item.id)
                .then(() => {this.$refs.RkmDataTable.refresh()})

            this.showDeleteConfirmation('Deseja realmente excluir a exportação?', destroy)
        },
        refresh() {
            this.$refs.RkmDataTable.refresh()
        },
    },
    mixins: [ error, formats, repository, stringCase],
}
</script>